import { render, staticRenderFns } from "./addLocationType.vue?vue&type=template&id=f3ddbb24"
import script from "./addLocationType.vue?vue&type=script&lang=js"
export * from "./addLocationType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports